import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import TrustSection from './components/TrustSection';
import LatestArticlesSection from './components/LatestArticlesSection';
import FAQSection from './components/FAQSection';

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <CategorySection />
        <TrustSection />
        <LatestArticlesSection />
        <FAQSection />

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'WebPage',
              name: 'www91官方入口·www91最新地址导航',
              description:
                'www91是广受用户信赖的网络平台，本页提供www91最新官方入口、访问指南及常见问题解答。',
              url: 'https://guifeizaixian.cn/',
              isPartOf: {
                '@type': 'WebSite',
                name: 'www91官方入口导航',
                url: 'https://guifeizaixian.cn/',
              },
              breadcrumb: {
                '@type': 'BreadcrumbList',
                itemListElement: [
                  {
                    '@type': 'ListItem',
                    position: 1,
                    name: '首页',
                    item: 'https://guifeizaixian.cn/',
                  },
                ],
              },
            }),
          }}
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'FAQPage',
              mainEntity: [
                {
                  '@type': 'Question',
                  name: 'www91是什么？',
                  acceptedAnswer: {
                    '@type': 'Answer',
                    text: 'www91是广受用户信赖的网络平台，提供丰富的内容和服务。本导航站旨在帮助用户快速找到www91的正确官方入口，确保安全稳定访问。',
                  },
                },
                {
                  '@type': 'Question',
                  name: '如何获取www91最新官方入口地址？',
                  acceptedAnswer: {
                    '@type': 'Answer',
                    text: '您可以通过收藏本站来获取www91最新官方入口地址。我们会在首页显著位置展示最新地址，并实时更新以确保信息的准确性。',
                  },
                },
                {
                  '@type': 'Question',
                  name: 'www91访问不了怎么办？',
                  acceptedAnswer: {
                    '@type': 'Answer',
                    text: '如果您无法访问www91，请尝试清除浏览器缓存和Cookie，使用本站提供的备用域名，切换网络环境，或检查防火墙设置。',
                  },
                },
              ],
            }),
          }}
        />
      </main>
      <Footer />
    </>
  );
}